import { TRANSLATIONS } from './translations';

// Curated per-value copy shown right below a field once the host picks a
// meaningful option -- only for the handful of fields most central to the
// listing (access, rental mode), not every single field in the wizard.
// Keyed by the same enum value used everywhere else (HeavyDutyMachineryOption.value),
// so it plugs straight into whichever field last changed without any extra
// mapping.
export const WIZARD_REINFORCEMENT_MESSAGES: Record<string, Record<string, string>> = {
  accessType: {
    SelfCheckin: TRANSLATIONS.WIZARD_REINFORCE_ACCESS_SELF_CHECKIN,
    HostGreets: TRANSLATIONS.WIZARD_REINFORCE_ACCESS_HOST_GREETS,
    HostPresentThroughout: TRANSLATIONS.WIZARD_REINFORCE_ACCESS_HOST_PRESENT_THROUGHOUT,
    OnsiteStaff: TRANSLATIONS.WIZARD_REINFORCE_ACCESS_ONSITE_STAFF,
  },
  rentalMode: {
    Hourly: TRANSLATIONS.WIZARD_REINFORCE_RENTAL_HOURLY,
    Overnight: TRANSLATIONS.WIZARD_REINFORCE_RENTAL_OVERNIGHT,
    Both: TRANSLATIONS.WIZARD_REINFORCE_RENTAL_BOTH,
    DayPass: TRANSLATIONS.WIZARD_REINFORCE_RENTAL_DAY_PASS,
  },
};
